import { useMemo } from 'react';

/**
 * Use this hook to replace useMemo(() => ({ a, b }), [a, b]) with useMemoizedBundle({ a, b }).
 *
 * @param bundle - Object whose properties will be memoized.
 * @returns The bundle.
 */
export const useMemoizedBundle = <T extends Parameters<(typeof Object)['values']>[0]>(
  bundle: T,
): T =>
  // biome-ignore lint/correctness/useExhaustiveDependencies: Object.values is the intentional dependency list
  useMemo(() => bundle, Object.values<unknown>(bundle));
